const father = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      // delay:1,
      delayChildren:1,
      staggerChildren: 1.2,
      duration: 2,
    },
  },
};

const childOne = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 1,

    },
  },
};

const childTwo = {
  hidden: {
    opacity: 0,
    y: -50,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
    },
    transitionEnd: {
      y: -50,
      opacity: 0,
    },
  },
};

const childThree = {
  hidden: {
    opacity: 0,
    y: -50,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
    },
  },
};

const childFour = {
  hidden: {
    x: '-100%',
  },
  visible: {
    x: 0,
    transition: {
      duration: 1,
    },
  },
};

const svgVariant = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 1,

    },

  },
};

const pathVariantOne = {
  hidden: {
    opacity: 0,
    width: 0,

  },
  visible: {
    opacity: 1,
    width: 681.1,
    transition: {
      // delay: 3.5,
      delay: 4.5,
      duration: 2,
      ease: 'easeInOut',
    },
  },
};

const pathVariantTwo = {
  hidden: {
    opacity: 0,
    height: 0,
  },
  visible: {
    opacity: 1,
    height: 427.2,
    transition: {
      // delay: 3.5,
      delay: 4.5,
      duration: 2,
      ease: 'easeInOut',
    },
  },
};

const pathVariantThree = {
  hidden: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    transition: {
      // delay: 3.5,
      delay: 4.5,

      duration: 2,
      ease: 'easeInOut',
    },
  },
};

const wordVariant = {
  hidden: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    transition: {
      // delay: 4.5,
      delay: 5.5,
      duration: 2,
      ease: 'easeOut',
    },
  },
  notActive: {
    fill: 'rgba(43, 43, 43,0)',
  },
  active: {
    fill: 'rgba(43, 43, 43,1)',
    transition: {
      // delay: 6.5,
      delay: 7.5,
      duration: 1,
      ease: 'easeOut',
    },
  },
};

const wordFillWhiteVariant = {
  hidden: {
    fill: 'rgba(255,255,255,0)',
  },
  visible: {
    fill: 'rgba(255,255,255,1)',
    transition: {
      // delay: 6.5,
      delay: 7.5,
      duration: 1,
      ease: 'easeOut',
    },
  },
};

const scrollVariant = {
  hidden: {
    y: -50,
  },
  visible: {
    y: 0,
    transition: {
      // delay: 6.5,
      delay: 7.5,
      duration: 0.5,
    },
  },
};

export const variantService = {
  father,
  childOne,
  childTwo,
  childThree,
  childFour,
  svgVariant,
  pathVariantOne,
  pathVariantTwo,
  pathVariantThree,
  wordVariant,
  wordFillWhiteVariant,
  scrollVariant,
};



// DONT DELETE THE COMMETS , INCASE OF REMOVING THE LOADER FROM HOME , UNCOMMENT THEM BACK